import React from 'react';
import { Container } from 'react-bootstrap';
import TPZCalculator from './components/TPZCalculator';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Container>
          <TPZCalculator />
        </Container>
      </header>
    </div>
  );
}

export default App;
